import { render, staticRenderFns } from "./LogbookTable.vue?vue&type=template&id=57416222&scoped=true&"
import script from "./LogbookTable.vue?vue&type=script&lang=js&"
export * from "./LogbookTable.vue?vue&type=script&lang=js&"
import style0 from "./LogbookTable.vue?vue&type=style&index=0&id=57416222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57416222",
  null
  
)

export default component.exports